var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953613H513V342.957H0V0.953613Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.953613H256.5V171.95H0V0.953613Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.806 97.6009L168.575 106.122H177.532L170.286 111.386L173.054 119.905L165.806 114.64L158.559 119.905L161.327 111.386L154.08 106.122H163.038L165.806 97.6009ZM120.814 30.6875L125.429 44.8882H140.358L128.28 53.6623L132.894 67.861L120.814 59.0859L108.737 67.861L113.351 53.6623L101.271 44.8882H116.201L120.814 30.6875ZM165.423 45.5575L170.038 59.7572H184.967L172.889 68.5313L177.502 82.7319L165.423 73.9548L153.346 82.7319L157.959 68.5313L145.88 59.7572H160.809L165.423 45.5575ZM130.163 105.036L134.778 119.236H149.707L137.628 128.011L142.241 142.21L130.163 133.434L118.085 142.21L122.698 128.011L110.619 119.236H125.549L130.163 105.036ZM91.0763 67.861L95.6903 82.0616H110.619L98.5409 90.8357L103.154 105.036L91.0763 96.2593L78.9978 105.036L83.6108 90.8357L71.5322 82.0616H86.4613L91.0763 67.861Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.955566)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/WS.696449f79043ca2bcebd18f17cba166a.svg";
export { ForwardRef as ReactComponent };